// LiveStreamEarnings.js
import { connect } from 'react-redux';
import addModal from '../action/addModal.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import LiveStreamEarnings from '../component/LiveStreamEarnings.jsx';

function mapStateToProps(state, { streamId }) {
  const giftDiamondCount = getLiveStreamData(
    state,
    [streamId, 'diamondCount'],
    'gift'
  );
  const viewDiamondCount = getLiveStreamData(
    state,
    [streamId, 'diamondCount'],
    'view'
  );
  const karaokeDiamondCount = getLiveStreamData(
    state,
    [streamId, 'diamondCount'],
    'karaoke'
  );
  const showDiamondCount = getLiveStreamData(
    state,
    [streamId, 'diamondCount'],
    'show'
  );
  return {
    giftDiamondCount,
    viewDiamondCount,
    karaokeDiamondCount,
    showDiamondCount,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, isHigherThanAll: true, transitionStatus: 'coming' })
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamEarnings);
